import request from '@/utils/request'
import { GetNewPersion, NewPersionMap, FetchInsuranceParam, MemberList, MemberMap, StatisticsParam, InsuranceListMap } from '@/types/newPersion'

/**
 * 退休规划查询接口
 * @param params
 */
export const newPersionList = (params: GetNewPersion) =>
  request({
    url: '/blackcat/pension/find',
    method: 'get',
    params
  })

/**
 * 保存退休规划
 */
export const savePension = (data: NewPersionMap) =>
  request({
    url: '/blackcat/pension/save',
    method: 'post',
    data
  })

/**
 * 退休规划需求图分析
 */
export const demandChart = (params: GetNewPersion) =>
  request({
    url: '/blackcat/pension/demands',
    method: 'get',
    params
  })

/**
 * 获取通货膨胀率接口
 */
export const rateList = () =>
  request({
    url: '/blackcat/pension/inflation/rate/list',
    method: 'get'
  })

/**
 * 获取城市等级对应养老费用列表
 */
export const costList = () =>
  request({
    url: '/blackcat/city/pension/cost/list',
    method: 'get'
  })

/**
 * 退休规划供给分析图
 */
export const supplyChart = (params: GetNewPersion) =>
  request({
    url: '/blackcat/pension/supplies',
    method: 'get',
    params
  })

/**
 * 退休规划供给分析图
 */
export const computeTree = () =>
  request({
    url: '/blackcat/ias/page/info/compute/tree',
    method: 'get'
  })

/**
 * 获取封面图
 */
export const coverImg = (params: {iasPageInfoId: string}) =>
  request({
    url: '/blackcat/ias/page/info/pic/find',
    method: 'get',
    params
  })

/**
 * 获取缺口分析
 */
export const getGapData = (params: {customerId: string}) =>
  request({
    url: `/blackcat/pension/gap?customerId=${params.customerId}`,
    method: 'get',
  })

// 查询保险产品列表
export const pensionInsuranceList = (params: FetchInsuranceParam) =>
  request({
    url: '/blackcat/insurance/list',
    method: 'get',
    params
  })

// 查询家庭成员列表
export const memberList = (params: MemberList) =>
  request({
    url: '/blackcat/customer/member/list',
    method: 'get',
    params
  })

// 家庭成员列表保存
export const memberSave = (data: MemberMap) =>
  request({
    url: '/blackcat/customer/member/save',
    method: 'post',
    data
  })

// 寿险类保险产品计算
export const statisticsList = (params: StatisticsParam) =>
  request({
    url: '/blackcat/insurance/action/life/statistics',
    method: 'get',
    params
  })
// 年金类保险计算
export const actionStatisticsList = (params: StatisticsParam) =>
  request({
    url: '/blackcat/insurance/action/statistics',
    method: 'get',
    params
  })

// 保险产品选择保存
export const pensionInsuranceSave = (data: {}, Pension: string) =>
  request({
    url: '/blackcat/insurance/action/save?storyLineType=' + Pension,
    method: 'post',
    data
  })

// 故事线类型下所有购买详情
export const pensionInsuranceSummaryList = (params: InsuranceListMap) =>
  request({
    url: '/blackcat/insurance/action/summary',
    method: 'get',
    params
  })

// v6-故事线类型下所有购买（带年缴费信息）
export const insuranceList = (params: InsuranceListMap) =>
  request({
    url: '/blackcat/insurance/action/list',
    method: 'get',
    params
  })

// 保险产品购买详情
export const pensionInsuranceSummaryDetail = (params: {id: string}) =>
  request({
    url: '/blackcat/insurance/action/detail',
    method: 'get',
    params
  })
// 退休规划汇总图
export const pensionListAll = (params: {customerId: string}) =>
  request({
    url: '/blackcat/pension/statistics',
    method: 'get',
    params
  })
